import { getComposeStore } from 'owa-calendar-compose-store-manager';

export default (): boolean => !getComposeStore().originalEvent?.ItemId;
